var React = require('react');

function IconYes (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 6c5.522 0 10 4.477 10 10 0 5.522-4.478 10-10 10S6 21.522 6 16c0-5.523 4.478-10 10-10zm0 2c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm4.674 3.89a.917.917 0 01.09 1.314L14.33 20.34a.968.968 0 01-1.444-.009l-1.658-2.03c-.342-.392-.294-.98.107-1.314s1.003-.286 1.344.105l.942 1.209 5.708-6.324a.97.97 0 011.345-.088z","fillRule":"evenodd"}));
}

IconYes.defaultProps = {"height":"32","width":"32"};

module.exports = IconYes;

IconYes.default = IconYes;
